import * as Sentry from "@sentry/react";

export function initSentry() {
  Sentry.init({
    dsn: "https://137287a12cada4d5752d5df3087ec581@o4510912728072192.ingest.us.sentry.io/4510912731021312",
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.3,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}

export { Sentry };
